import { render, staticRenderFns } from "./homeBottom.vue?vue&type=template&id=daeadef4&scoped=true"
import script from "./homeBottom.vue?vue&type=script&lang=js"
export * from "./homeBottom.vue?vue&type=script&lang=js"
import style0 from "./homeBottom.vue?vue&type=style&index=0&id=daeadef4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daeadef4",
  null
  
)

export default component.exports